module.exports = __webpack_public_path__ + "img/jinan-city.png";